<script setup lang="ts">
import { definePage } from "unplugin-vue-router/runtime";
import { computed, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { useSnackStore } from "@/stores/snackStore";
import EntityCardSkeleton from "@/components/models/message/skeletons/EntityCardSkeleton.vue";
import ChatMessagesSkeleton from "@/components/models/message/skeletons/ChatMessagesSkeleton.vue";
import ChatInvitesLayout from "@/components/models/practice/practiceStaff/ChatInvitesLayout.vue";
import { useRoomQuery } from "@/composables/models/message/useRoom.ts";

definePage({
  meta: {
    title: "generic.action.viewEntity",
    titleParams: { entity: "generic.entity.invite" },
    layout: "rooms",
  },
});

const { t } = useI18n();
const router = useRouter();
const route = useRoute();
const roomId = computed(() => (route.params as { id: string }).id);

const { data: room, isLoading, error } = useRoomQuery({ id: roomId });

const snackStore = useSnackStore();

watch(
  () => error.value,
  async (error) => {
    if (error && "status" in error && String(error.status).startsWith("4")) {
      await router.push({
        name: "/",
      });
      snackStore.showError(
        t("generic.errors.notFoundOrNoAccessToEntity", { entity: t("generic.entity.invite") })
      );
    }
  },
  { immediate: true }
);
</script>

<template>
  <chat-invites-layout
    v-if="room && !isLoading"
    :room="room"
  />
  <div
    v-else
    class="tw:flex tw:flex-1 tw:h-full tw:overflow-hidden tw:bg-background tw:rounded-tl-xl"
  >
    <div class="tw:hidden tw:md:block tw:w-[30%] tw:h-full tw:flex-shrink-0 tw:!my-1">
      <entity-card-skeleton />
    </div>
    <div class="tw:flex-1 tw:h-full tw:min-w-0 tw:md:!mt-1">
      <chat-messages-skeleton />
    </div>
  </div>
</template>
